'use client';
import { ApiClientModalProvider, useApiClientModal } from '@scalar/api-client-react';
import { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useOpenAPIOperationContext } from './OpenAPIOperationContext';
import { t } from './translate';
/**
 * Button which launches the Scalar API Client
 */
export function ScalarApiButton(props) {
    var method = props.method, path = props.path, specUrl = props.specUrl, context = props.context;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var controllerRef = useRef(null);
    return (<div className="scalar scalar-activate">
            <button className="scalar-activate-button button" onClick={function () {
            var _a, _b;
            (_b = (_a = controllerRef.current) === null || _a === void 0 ? void 0 : _a.openClient) === null || _b === void 0 ? void 0 : _b.call(_a);
            setIsOpen(true);
        }}>
                {t(context.translation, 'test_it')}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 12" fill="currentColor">
                    <path stroke="currentColor" strokeWidth="1.5" d="M1 10.05V1.43c0-.2.2-.31.37-.22l7.26 4.08c.17.1.17.33.01.43l-7.26 4.54a.25.25 0 0 1-.38-.21Z"/>
                </svg>
            </button>

            {isOpen &&
            createPortal(<ScalarModal controllerRef={controllerRef} method={method} path={path} specUrl={specUrl}/>, document.body)}
        </div>);
}
function ScalarModal(props) {
    var method = props.method, path = props.path, specUrl = props.specUrl, controllerRef = props.controllerRef;
    return (<ApiClientModalProvider configuration={{ url: specUrl }} initialRequest={{ method: method, path: path }}>
            <ScalarModalController method={method} path={path} controllerRef={controllerRef}/>
        </ApiClientModalProvider>);
}
function ScalarModalController(props) {
    var method = props.method, path = props.path, controllerRef = props.controllerRef;
    var client = useApiClientModal();
    var openScalarClient = client === null || client === void 0 ? void 0 : client.open;
    var trackClientOpening = useOpenAPIOperationContext().onOpenClient;
    var openClient = useMemo(function () {
        if (openScalarClient) {
            return function () {
                openScalarClient({ method: method, path: path, _source: 'gitbook' });
                trackClientOpening({ method: method, path: path });
            };
        }
        return null;
    }, [openScalarClient, method, path, trackClientOpening]);
    useImperativeHandle(controllerRef, function () { return ({ openClient: openClient ? function () { return openClient(); } : undefined }); }, [openClient]);
    // Open at mount
    useEffect(function () {
        openClient === null || openClient === void 0 ? void 0 : openClient();
    }, [openClient]);
    return null;
}
